import { setPosts, appendPosts, setLoading } from "../store/slices/PostSlice";
import { setShorts, appendShorts } from "../store/slices/ShortSlice";
import { setPlaces, appendPlaces } from "../store/slices/PlacesSlice";
import { request } from "../Utils/request";
import { getPublicUrlFromFileKey } from "./API/Api";

 export const extractHashtags = (text: string): string[] => {
    const hashtagRegex = /#[a-zA-Z0-9][a-zA-Z0-9_]*/g;
    const matches = text.match(hashtagRegex) || [];
    return matches.map(tag => tag.slice(1).toLowerCase());
  };

  export const followUser = async (id: string) => {
    const res = await request(`/profile/${id}/follow`, {
      method: 'POST',
      authorization: true,
    }) as any;
    return res.data;
  }

  export const getAllPublicUrls = async (filekeys: string[]) => {
    const responses = await Promise.all(
        filekeys.map(key => getPublicUrlFromFileKey(key))
    );
    return responses.map(res => res.data.files[0].viewUrl);
};

export const likePost = async (id: string) => {
  try {
    const response = await request(`/posts/${id}/like`, {
      method: 'POST',
      authorization: true,
    }) as any;
    return response;
  } catch (error) {
    console.log('Error liking post:', error);
    throw error;
  }
};

export const bookmarkPost = async (id: string) => {
  const response = await request(`/profile/saved-posts/${id}`, {
    method: 'POST',
    authorization: true,
  }) as any;
  return response;
};

export const fetchPosts = async (dispatch: any, fileType: string, page: number = 1, limit: number = 5, append: boolean = false) => {
  try {
      dispatch(setLoading(true));
      const response = await request<any>(`/posts/?fileType=${fileType}&page=${page}&limit=${limit}`, {
          method: 'GET',
          authorization: true,
      });
      const postData = response?.data;
      
      if(fileType === 'image'){
        if(append) {
          dispatch(appendPosts(postData));
        } else {
          dispatch(setPosts(postData));
        }
      } else {
        if(append) {
          dispatch(appendShorts(postData));
        } else {
          dispatch(setShorts(postData));
        }
      }
  } catch (error) {
      console.error('Error fetching posts:', error);
  } finally {
      dispatch(setLoading(false));
  }
};

export const fetchPlaces = async (dispatch: any, page: number = 1, limit: number = 5, append: boolean = false) => {
  try {
      dispatch(setLoading(true));
      const response = await request<any>(`/places?page=${page}&limit=${limit}`, {
          method: 'GET',
          authorization: true,
      });
      const placesData = response?.data;
      
      if(append) {
        dispatch(appendPlaces(placesData));
      } else {
        dispatch(setPlaces(placesData));
      }
  } catch (error) {
      console.error('Error fetching places:', error);
  } finally {
      dispatch(setLoading(false));
  }
};

export const fetchUserPosts = async (
  dispatch: any,
  userId: string,
  page: number = 1,
  limit: number = 12,
  append: boolean = false,
  options?: { type?: string }
) => {
  try {
      dispatch(setLoading(true));
      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
      });

      if (options?.type) {
        queryParams.append('type', options.type);
      }

      const response = await request<any>(`/posts/user/${userId}?${queryParams.toString()}`, {
          method: 'GET',
          authorization: true,
      });
      const postData = response?.data?.posts || response?.data || [];
      
      if(append) {
        dispatch(appendPosts(postData));
      } else {
        dispatch(setPosts(postData));
      }
  } catch (error) {
      console.error('Error fetching user posts:', error);
      // Try fallback endpoint
      try {
        const fallbackQueryParams = new URLSearchParams({
          userId,
          page: page.toString(),
          limit: limit.toString(),
        });

        if (options?.type) {
          fallbackQueryParams.append('type', options.type);
        }

        const fallbackResponse = await request<any>(`/posts/?${fallbackQueryParams.toString()}`, {
          method: 'GET',
          authorization: true,
        });
        const fallbackData = fallbackResponse?.data?.posts || fallbackResponse?.data || [];
        
        if(append) {
          dispatch(appendPosts(fallbackData));
        } else {
          dispatch(setPosts(fallbackData));
        }
      } catch (fallbackError) {
        console.error('Fallback endpoint also failed:', fallbackError);
      }
  } finally {
      dispatch(setLoading(false));
  }
};

export const fetchExploreTrips = async (page: number = 1, limit: number = 5, search?: string, category?: string) => {
  try {
    // Build query parameters
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(search && { search }),
      ...(category && category !== 'All' && { category })
    });

    const response = await request<{ 
      success: boolean; 
      data: any[], 
      message: string;
      pagination?: {
        currentPage: number;
        totalPages: number;
        hasNextPage: boolean;
      }
    }>(`/profile/explorer?${queryParams.toString()}`, {
      method: 'GET'
    });

    return {
      data: response?.data || [],
      pagination: response?.pagination,
      hasMore: response?.pagination?.hasNextPage ?? (response?.data?.length === limit)
    };
  } catch (error) {
    console.error('Error fetching explore trips:', error);
    throw error;
  }
};